'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        imageBrowserFileTypes: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.fileTypes'
        },
        imageBrowserPath: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.path'
        },
        imageBrowserTransportRead: {
            type: [String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.read'
        },
        imageBrowserTransportReadContentType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.read.contentType'
        },
        imageBrowserTransportReadData: {
            type: [Object, String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.read.data'
        },
        imageBrowserTransportReadDataType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.read.dataType'
        },
        imageBrowserTransportReadType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.read.type'
        },
        imageBrowserTransportReadUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.read.url'
        },
        imageBrowserTransportThumbnailUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.thumbnailUrl'
        },
        imageBrowserTransportUploadUrl: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.uploadUrl'
        },
        imageBrowserTransportImageUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.imageUrl'
        },
        imageBrowserTransportDestroy: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.destroy'
        },
        imageBrowserTransportDestroyContentType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.destroy.contentType'
        },
        imageBrowserTransportDestroyData: {
            type: [Object, String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.destroy.data'
        },
        imageBrowserTransportDestroyDataType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.destroy.dataType'
        },
        imageBrowserTransportDestroyType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.destroy.type'
        },
        imageBrowserTransportDestroyUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.destroy.url'
        },
        imageBrowserTransportCreate: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.create'
        },
        imageBrowserTransportCreateContentType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.create.contentType'
        },
        imageBrowserTransportCreateData: {
            type: [Object, String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.create.data'
        },
        imageBrowserTransportCreateDataType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.create.dataType'
        },
        imageBrowserTransportCreateType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.transport.create.type'
        },
        imageBrowserTransportCreateUrl: {
            type: [String, Function],
            default: undefined,
            kComposite: 'imageBrowser.transport.create.url'
        },
        imageBrowserSchemaModelId: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.id'
        },
        imageBrowserSchemaModelFieldsName: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.name'
        },
        imageBrowserSchemaModelFieldsNameField: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.name.field'
        },
        imageBrowserSchemaModelFieldsNameParse: {
            type: Function,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.name.parse'
        },
        imageBrowserSchemaModelFieldsType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.type'
        },
        imageBrowserSchemaModelFieldsTypeParse: {
            type: Function,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.type.parse'
        },
        imageBrowserSchemaModelFieldsTypeField: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.type.field'
        },
        imageBrowserSchemaModelFieldsSize: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.size'
        },
        imageBrowserSchemaModelFieldsSizeField: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.size.field'
        },
        imageBrowserSchemaModelFieldsSizeParse: {
            type: Function,
            default: undefined,
            kComposite: 'imageBrowser.schema.model.fields.size.parse'
        },
        imageBrowserMessagesUploadFile: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.uploadFile'
        },
        imageBrowserMessagesOrderBy: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.orderBy'
        },
        imageBrowserMessagesOrderByName: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.orderByName'
        },
        imageBrowserMessagesOrderBySize: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.orderBySize'
        },
        imageBrowserMessagesDirectoryNotFound: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.directoryNotFound'
        },
        imageBrowserMessagesEmptyFolder: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.emptyFolder'
        },
        imageBrowserMessagesDeleteFile: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.deleteFile'
        },
        imageBrowserMessagesInvalidFileType: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.invalidFileType'
        },
        imageBrowserMessagesOverwriteFile: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.overwriteFile'
        },
        imageBrowserMessagesSearch: {
            type: String,
            default: undefined,
            kComposite: 'imageBrowser.messages.search'
        }
    }
};